/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/pipeline.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiRelationship } from './ApiRelationship';
import {
  ApiRelationshipFromJSON,
  ApiRelationshipFromJSONTyped,
  ApiRelationshipToJSON,
  ApiRelationshipToJSONTyped,
} from './ApiRelationship';
import type { ApiResourceKey } from './ApiResourceKey';
import {
  ApiResourceKeyFromJSON,
  ApiResourceKeyFromJSONTyped,
  ApiResourceKeyToJSON,
  ApiResourceKeyToJSONTyped,
} from './ApiResourceKey';

/**
 *
 * @export
 * @interface ApiResourceReference
 */
export interface ApiResourceReference {
  /**
   *
   * @type {ApiResourceKey}
   * @memberof ApiResourceReference
   */
  key?: ApiResourceKey;
  /**
   * The name of the resource that referred to.
   * @type {string}
   * @memberof ApiResourceReference
   */
  name?: string;
  /**
   *
   * @type {ApiRelationship}
   * @memberof ApiResourceReference
   */
  relationship?: ApiRelationship;
}

/**
 * Check if a given object implements the ApiResourceReference interface.
 */
export function instanceOfApiResourceReference(value: object): value is ApiResourceReference {
  return true;
}

export function ApiResourceReferenceFromJSON(json: any): ApiResourceReference {
  return ApiResourceReferenceFromJSONTyped(json, false);
}

export function ApiResourceReferenceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiResourceReference {
  if (json == null) {
    return json;
  }
  return {
    key: json['key'] == null ? undefined : ApiResourceKeyFromJSON(json['key']),
    name: json['name'] == null ? undefined : json['name'],
    relationship:
      json['relationship'] == null ? undefined : ApiRelationshipFromJSON(json['relationship']),
  };
}

export function ApiResourceReferenceToJSON(json: any): ApiResourceReference {
  return ApiResourceReferenceToJSONTyped(json, false);
}

export function ApiResourceReferenceToJSONTyped(
  value?: ApiResourceReference | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    key: ApiResourceKeyToJSON(value['key']),
    name: value['name'],
    relationship: ApiRelationshipToJSON(value['relationship']),
  };
}
